import { useState } from "react";
import { motion } from "framer-motion";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { useT } from "../lib/prefs";

export const FEEDBACK_IMAGES = Array.from({ length: 10 }, (_, i) => `/img/fb${i + 1}.webp`);

const Row = ({ hidden, onOpen, alt }) => (
  <div className="flex shrink-0 gap-4 sm:gap-6 pr-4 sm:pr-6" aria-hidden={hidden}>
    {FEEDBACK_IMAGES.map((src, i) => (
      <button
        key={src}
        onClick={() => onOpen(src)}
        tabIndex={hidden ? -1 : 0}
        data-testid={hidden ? undefined : `feedback-card-${i}`}
        className="relative w-[260px] sm:w-[320px] aspect-[4/5] rounded-3xl overflow-hidden border border-violet-400/25 shadow-[0_20px_60px_-20px_rgba(124,58,237,0.6)] transition-transform duration-500 hover:-translate-y-2"
      >
        <img src={src} alt={`${alt} ${i + 1}`} loading="lazy" className="w-full h-full object-cover" />
      </button>
    ))}
  </div>
);

export const FeedbackSection = () => {
  const t = useT();
  const [active, setActive] = useState(null);
  return (
    <section className="relative py-24 sm:py-32 overflow-hidden" data-testid="feedback-section">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-7xl mx-auto px-5 sm:px-8 mb-12"
      >
        <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
          {t.fbTitleA}<span className="text-gradient">{t.fbTitleB}</span>
        </h2>
        <p className="mt-4 text-sm text-violet-100/75">{t.fbHint}</p>
      </motion.div>

      <div className="flex w-max animate-marquee-fb" data-testid="feedback-marquee">
        <Row onOpen={setActive} alt={t.fbAlt} />
        <Row hidden onOpen={setActive} alt={t.fbAlt} />
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent data-testid="feedback-lightbox" className="bg-[#0B0518] border border-violet-400/30 p-2 sm:p-3 rounded-3xl max-w-[92vw] sm:max-w-xl">
          <DialogTitle className="sr-only">{t.fbAlt}</DialogTitle>
          {active && <img src={active} alt={t.fbAlt} className="w-full max-h-[80vh] object-contain rounded-2xl" />}
        </DialogContent>
      </Dialog>
    </section>
  );
};
